export const GET_DEMO_REQUESTS_REQUEST = "GET_DEMO_REQUESTS_REQUEST";

export const GET_DEMO_REQUESTS_RESPONSE = "GET_DEMO_REQUESTS_RESPONSE";

export const UPDATE_DEMO_REQUEST_REQUEST = "UPDATE_DEMO_REQUEST_REQUEST";

export const DELETE_DEMO_REQUEST_REQUEST = "DELETE_DEMO_REQUEST_REQUEST";
